<mat-sidenav-container fullscreen>
	<mat-menu #menu="matMenu">
		<mat-nav-list>
			<button mat-menu-item routerLink="/home" routerLinkActive="active-route">
				<mat-icon mat-list-icon>home</mat-icon>
				<span matLine>Inicial</span>
			</button>
			<mat-divider></mat-divider>
			<button mat-menu-item routerLink="/lista-cotacoes" routerLinkActive="active-route">
				<mat-icon mat-list-icon>assignment</mat-icon>
				<span matLine>Cotações</span>
			</button>
			<mat-divider></mat-divider>
			<mat-divider></mat-divider>
			<button mat-menu-item (click)="logout()">
				<mat-icon mat-list-icon>exit_to_app</mat-icon>
				<span matLine>Logout</span>
			</button>
		</mat-nav-list>
	</mat-menu>
	<mat-toolbar color="primary">
		<button mat-icon-button style="margin-right: 25px;" [matMenuTriggerFor]="menu">
			<mat-icon>menu</mat-icon>
		</button>
		<span class="app-fill-remaining-space"></span>
		<img id="clienteImage" src="assets/images/sua_logo.png" class="logo-filial" alt="Avatar" />
		<img src="assets/images/favicon.png" class="logo-filial" alt="Avatar" />
	</mat-toolbar>

	<div jafxLayout="column" fxLayoutGap="10px" fxLayoutWrap fxLayout.gt-xs="row">
		<mat-card id="cotacoes" style="width: 100%;">
			<mat-card-header>
				<div mat-card-avatar>
					<mat-icon mat-list-icon>assignment</mat-icon>
				</div>
				<mat-card-title>Cotações</mat-card-title>
				<mat-card-subtitle>Estatísticas</mat-card-subtitle>
			</mat-card-header>
			<mat-divider></mat-divider>
			<mat-card-content>
				<mat-grid-list cols="15" rowHeight="20px">
					<mat-grid-tile *ngIf="nColunas() === '3'" [rowspan]="12" [colspan]="2"></mat-grid-tile>
					<mat-grid-tile [rowspan]="12" [colspan]=nColunas()>
						<a class="btn-finalizado" routerLink="/lista-cotacoes">
							<mat-card class="example-card">
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="5">
											<mat-icon class="mat-48">check_circle</mat-icon>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
								<mat-divider class="divider-margin"></mat-divider>
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="3">
											<h1>{{nFinalizadas}}</h1>
										</mat-grid-tile>
										<mat-grid-tile [rowspan]="3">
											<mat-card-subtitle>Finalizadas</mat-card-subtitle>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
							</mat-card>
						</a>
					</mat-grid-tile>

					<mat-grid-tile *ngIf="nColunas() === '3'" [rowspan]="12" [colspan]="1"></mat-grid-tile>

					<mat-grid-tile [rowspan]="12" [colspan]=nColunas()>
						<a class="btn-edicao" routerLink="/lista-cotacoes">
							<mat-card class="example-card">
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="5">
											<mat-icon class="mat-48">error</mat-icon>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
								<mat-divider class="divider-margin"></mat-divider>
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="3">
											<h1>{{nEdicao}}</h1>
										</mat-grid-tile>
										<mat-grid-tile [rowspan]="3">
											<mat-card-subtitle>Edição</mat-card-subtitle>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
							</mat-card>
						</a>
					</mat-grid-tile>

					<mat-grid-tile *ngIf="nColunas() === '3'" [rowspan]="12" [colspan]="1"></mat-grid-tile>

					<mat-grid-tile [rowspan]="12" [colspan]=nColunas()>
						<a class="btn-novo" routerLink="/lista-cotacoes">
							<mat-card class="example-card">
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="5">
											<mat-icon class="mat-48">new_releases</mat-icon>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
								<mat-divider class="divider-margin"></mat-divider>
								<mat-card-content>
									<mat-grid-list class="coluna-card" cols="1" rowHeight="10px">
										<mat-grid-tile [rowspan]="3">
											<h1>{{nNovas}}</h1>
										</mat-grid-tile>
										<mat-grid-tile [rowspan]="3">
											<mat-card-subtitle>Novas</mat-card-subtitle>
										</mat-grid-tile>
									</mat-grid-list>
								</mat-card-content>
							</mat-card>
						</a>
					</mat-grid-tile>
				</mat-grid-list>
			</mat-card-content>
		</mat-card>
	</div>
</mat-sidenav-container>